import api from 'networkapp-api-connector';
import { recursiveKeyReplacement } from '../data/misc/recursiveKeyReplacement/recursiveKeyReplacement';

function replaceParticipantKeys(lead) {
    return recursiveKeyReplacement('_participant_id', 'participant_id', lead);
}

export default {
    downloadFile: (eventId, eventName) => {
        return api.leads.downloadFile(eventId, eventName);
    },
    get: (eventId) => {
        return api.leads.get(eventId).then(({ result }) => {
            result = replaceParticipantKeys(result);
            app.store.dispatch(app.actions.leads.load(eventId, result));
        });
    },
    create: (eventId, sponsorId, code) =>
        api.leads.create(eventId, sponsorId, code).then((newLead) => {
            newLead = replaceParticipantKeys(newLead);
            app.store.dispatch(app.actions.leads.update(eventId, newLead));
            return newLead;
        }),
    update: (eventId, uuid, fields) =>
        api.leads.update(eventId, uuid, fields).then((updatedLead) => {
            updatedLead = replaceParticipantKeys(updatedLead);
            app.store.dispatch(app.actions.leads.update(eventId, updatedLead));
            return updatedLead;
        }),
};
